export default __webpack_public_path__ + "static/sz_hu_3-b1930f3029c9629dab5486209c48f642.mp4";